import {
  ParametricAssetId,
  SubmittingOrganization,
  type ParametricAsset,
} from "@/types";

type AssetParams = {
  H: number; // Hauteur du poteau vertical
  eh: number; // Épaisseur du poteau vertical
  L: number; // Longueur de la console horizontale
  el: number; // Épaisseur de la console horizontale
  t2: number; // Largeur de la base
  e2: number; // Épaisseur de la base
  t1: number; // Largeur du renfort
  e1: number; // Épaisseur du renfort
};

const asset: ParametricAsset<AssetParams> = {
  id: ParametricAssetId.CANTILEVER,
  image: "/images/assets/potence.png",
  submittedBy: SubmittingOrganization.PCM,
  inputs: [
    { key: "H", type: "dimension" },
    { key: "eh", type: "dimension" },
    { key: "L", type: "dimension" },
    {
      key: "el",
      type: "dimension",
    },
    { key: "t2", type: "dimension" },
    { key: "e2", type: "dimension" },
    { key: "t1", type: "dimension" },
    { key: "e1", type: "dimension" },
  ],
  build: (params, offset) => {
    const { H, L, eh, el, t2, e2, t1, e1 } = params;

    const bDelta = (t2 - eh) / 2;
    const rDelta = (t1 - el) / 2;

    return [
      {
        // Poteau vertical
        type: "polyline",
        points: [
          [offset[0], offset[1], offset[2]],
          [offset[0] + eh, offset[1], offset[2]],
          [offset[0] + eh, offset[1] - H, offset[2]],
          [offset[0], offset[1] - H, offset[2]],
          [offset[0], offset[1], offset[2]],
        ],
      },
      {
        // Renfort
        type: "polyline",
        points: [
          [offset[0] + eh, offset[1] + rDelta, offset[2]],
          [offset[0] + eh + e1, offset[1] + rDelta, offset[2]],
          [offset[0] + eh + e1, offset[1] - el - rDelta, offset[2]],
          [offset[0] + eh, offset[1] - el - rDelta, offset[2]],
          [offset[0] + eh, offset[1] + rDelta, offset[2]],
        ],
      },
      {
        // Console horizontale
        type: "polyline",
        points: [
          [offset[0] + eh + e1, offset[1], offset[2]],
          [offset[0] + eh + e1 + L, offset[1], offset[2]],
          [offset[0] + eh + e1 + L, offset[1] - el, offset[2]],
          [offset[0] + eh + e1, offset[1] - el, offset[2]],
          [offset[0] + eh + e1, offset[1], offset[2]],
        ],
      },
      {
        // Base
        type: "polyline",
        points: [
          [offset[0] - bDelta, offset[1] - H, offset[2]],
          [offset[0] + eh + bDelta, offset[1] - H, offset[2]],
          [offset[0] + eh + bDelta, offset[1] - H - e2, offset[2]],
          [offset[0] - bDelta, offset[1] - H - e2, offset[2]],
          [offset[0] - bDelta, offset[1] - H, offset[2]],
        ],
      },
    ];
  },
};
export default asset;
